import { type AnalyticsBrowser } from '@segment/analytics-next'
import { errors } from '../../../error-handling/errors'
import clientEnv from '../../../../utils/global/clientEnv'
import { isAnalyticsEnabled } from '../../../events/analytics'
import { eventTrackingEnabled } from './eventDebugging'
import { type GlobalAnalytics } from './segmentAnalytics.types'

const noop = () => {
  // noop
}
export const noopSegmentAnalytics = {
  alias: noop,
  group: noop,
  identify: noop,
  page: noop,
  track: noop,
}

export const segmentAnalytics = (): AnalyticsBrowser | typeof noopSegmentAnalytics => {
  const globalWithAnalytics = (global as GlobalAnalytics).analytics

  if (!eventTrackingEnabled()) {
    return noopSegmentAnalytics
  }

  // If the analytics module is not enabled, then we should return early
  // Only log an error if initialization was attempted but failed (not if we're waiting for consent)
  if (!globalWithAnalytics) {
    // Skip logging in these cases:
    // 1. Local/development environments (Cypress runs production build without env vars)
    // 2. When OneTrust is configured but consent flow hasn't completed yet
    const isNonProdEnv =
      clientEnv.PUBLIC_CLIENT_ENVIRONMENT != null &&
      ['local', 'development'].includes(clientEnv.PUBLIC_CLIENT_ENVIRONMENT)

    if (!isNonProdEnv && isAnalyticsEnabled()) {
      const errorMessage =
        'Segment `analytics` module unavailable - script was missing or failed to load'
      console.warn(errorMessage)
      errors.captureMessage(errorMessage, { level: 'error' })
    }
    return noopSegmentAnalytics
  }

  return globalWithAnalytics
}

export const SEGMENT_OPTIONS = {}
